export default __webpack_public_path__ + "static/media/Qlik-Sense.133c2ae8.svg";